import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { BonusAccount } from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'

export const accountsMounted = createEvent()

export const setAccountsRequestError = createEvent<RequestError>()

export const getBonusAccounts = fx<void, BonusAccount[]>({
  method: 'GET',
  url: '/client/{clientId}/bonus111',
})

export const $accounts = restore<BonusAccount[]>(
  getBonusAccounts.doneData.map((doneData) => doneData.body),
  [],
)

export const $errorAccountsRequest = restore(setAccountsRequestError, {
  message: '',
  code: 0,
})

sample({
  clock: [accountsMounted],
  source: $params,
  fn: (params) => {
    return {
      query: {
        where: `{"id":"${params?.clientID}"}`,
      },
      url: `/client/${params?.clientID}/bonus111`,
    }
  },
  target: [getBonusAccounts],
})

sample({
  clock: getBonusAccounts.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setAccountsRequestError],
})
